import { defineStore } from "pinia";
import { useMultiAdditionalServiceField } from "@/features/experience-curation/lib/useAdditionalServiceField";
import { useHasFunctionalFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";

export const useCurationFeatures = defineStore("curation-content-features-field", () => {
  const field = useMultiAdditionalServiceField({
    id: "features",
    functionalGroupCode: "FEATURES",
  });
  const hasUnpublishedChange = useHasFunctionalFieldChange("features");

  return { ...field, hasUnpublishedChange };
});
